module.exports = __webpack_public_path__ + "img/builder-20.060e2a87.webp";